import api from "../api";

export const getPlans = (data) => {
  return api.getApi().get(api.getBaseUrl() + "plans");
};
export const getPlan = (id) => {
  return api.getApi().get(api.getBaseUrl() + "plans/" + id);
};
export const createPlan = (data) => {
  return api.getApi().post(api.getBaseUrl() + "plans", data);
};

export const updatePlan = (id, data) => {
  console.log("data", id);
  return api.getApi().put(api.getBaseUrl() + "plans/" + id, data);
};
export const getProfile = () => {
  return api.getApi().get(api.getBaseUrl() + "profile");
};

export const deletePlan = (id) => {
  return api.getApi().delete(api.getBaseUrl() + "plans/" + id);
};

export const getActivePlans = (data) => {
  return api.getApiWithoutToken().get(api.getBaseUrl() + "getPlans");
};
